import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

interface IconifyProps {
  icon: string;
  width?: number | string;
  sx?: object;
  style?: object;
}

const Iconify = forwardRef(
  ({ icon, width = 20, sx, style, ...other }: IconifyProps, ref) => (
    <Box
      ref={ref}
      component={Icon}
      icon={icon}
      sx={{ width, height: width, ...sx }}
      style={style}
      {...other}
    />
  )
);

Iconify.displayName = 'Iconify';

export default Iconify;
